<template>
  <div class="panel">
    <header>
      <h4>Combat Initiative Tracker</h4>
    </header>
    <section>
      <button class="hidden" ref="comabtGrid_addButton" v-on:click="add">Alt + A</button>
      <div id="comabtGrid">
        <div v-if="tracker.items.length <= 0">
          <h3>No current combatants.</h3>
          <button v-on:click="add">Start Combat</button>
        </div>
        <table v-if="tracker.items.length > 0">
          <caption>Initiative Tracker&nbsp;&nbsp;Current Pass: {{tracker.currentPass}}&nbsp;&nbsp;<button v-on:click="add">Add Combatant</button></caption>
          <thead>
            <tr>
              <th>Combatant</th>
              <th>Current Initiative</th>
              <th>Initiative Score</th>
              <th>Pass</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <td colspan="5">
                <button v-on:click="clear">Clear</button>
                <button v-on:click="reset">New Round</button>
              </td>
            </tr>
          </tfoot>
          <tbody>
            <tr class="combatantRow"
                v-for="(item, index) in tracker.items"
                v-bind:item="item"
                v-bind:index="index"
                v-bind:key="item.Id"
                v-bind:class="{ exhausted: item.isExhausted() }"
                v-on:click.capture="openCombatDialogByCaptureEvent($event, [item])">
              <td>{{item.Name}}</td>
              <td>{{item.Initiative}}</td>
              <td>{{item.Score}}</td>
              <td>{{item.Pass}}</td>
              <td>
                <button v-if="item.Initiative > 5" v-on:click="changeInitiative(index, -5)">-5</button>&nbsp;
                <button v-if="item.Initiative > 7" v-on:click="changeInitiative(index, -7)">-7</button>&nbsp;
                <button v-if="item.Initiative > 10" v-on:click="changeInitiative(index, -10)">-10</button>&nbsp;
                <button v-on:click="modify(index)">+/-</button>&nbsp;
                <button v-if="item.Initiative > 0 && item.Pass === tracker.currentPass" v-on:click="changeInitiative(index, -10, true)">End Pass</button>&nbsp;
                <button v-on:click="remove(index)">Remove</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id="combatantDialog" class="modal" v-show="showCombatantDialog">
        <div class="modal-content">
          <header>Combatant Editor</header>
          <section>
            <div>
              <label for="name">Name:</label>
              <input type="text" ref="combatantDialog_name" name="name" tabindex="1" v-model="combatantDialogModel.currentItem.Name" v-on:keypress.enter="nextElement" />
            </div>
            <div>
              <label for="initiative">Initiative:</label>
              <input type="number" ref="combatantDialog_initiative" name="initiative" tabindex="2" v-model.number="combatantDialogModel.currentItem.Initiative" v-on:keypress.enter="moveNextOrSave" />
            </div>
            <div>
              <label for="seize">Seize the Initiative:</label>
              <input type="checkbox" ref="combatantDialog_seize" name="seize" tabindex="3" v-model="combatantDialogModel.currentItem.Priority" />
            </div>
          </section>
          <footer><button v-if="combatantDialogModel.items.length > 1 && combatantDialogModel.currentIndex > 0" v-on:click="movePrev">Previous</button>&nbsp;&nbsp;<button v-if="combatantDialogModel.items.length > 1 && combatantDialogModel.currentIndex < (combatantDialogModel.items.length - 1)" v-on:click="moveNext">Next</button>&nbsp;&nbsp;<button v-on:click="closeDialog('combatantDialog')">Close</button>&nbsp;&nbsp;<button v-on:click="saveCombatant">Save</button></footer>
        </div>
      </div>
      <div id="initiativeDialog" class="modal" v-show="showInitiativeDialog">
        <div class="modal-content">
          <header>Intiatiave Editor</header>
          <section>
            <div>
              <label for="isGlobal">Affect Score and Current:</label>
              <input name="isGlobal" ref="initiativeDialog_isGlobal" type="checkbox" tabindex="1" v-model="initiativeDialogModel.IsGlobal" />
            </div>
            <div>
              <label for="initMod">Modify Initiative By:</label>
              <input name="initMod" ref="initiativeDialog_modifier" type="number" tabindex="2" v-model.number="initiativeDialogModel.Modifier" v-on:keypress.enter="saveInitiative" />
            </div>
          </section>
          <footer><button v-on:click="closeDialog('initiativeDialog')">Close</button>&nbsp;&nbsp;<button v-on:click="saveInitiative">Save</button></footer>
        </div>
      </div>
    </section>
    <footer></footer>
  </div>
</template>
<script>
export default {
  name: 'InitiativeTracker',
  data () {
    return {
      message: '',
      tracker: { items: [], lastId: 1, currentPass: 1 },
      combatantDialogModel: { items: [], currentIndex: 0, currentItem: new Combatant(0, 0, '', false) },
      initiativeDialogModel: { Modifier: 0, Index: -1, IsGlobal: false },
      showCombatantDialog: false,
      showInitiativeDialog: false
    }
  },
  methods: {
    add () {
      this.openCombatDialog([new Combatant(this.tracker.lastId++, 0, 'Unknown')])
    },
    changeInitiative (index, modifier, pass) {
      if (pass === null || pass === undefined) { pass = false }
      let init = this.tracker.items[index].Initiative
      if (init - modifier <= 0) { init = 0 } else { init += modifier }
      this.tracker.items[index].Pass += 1
      this.tracker.items[index].Initiative = init
      let checkPass = this.tracker.items.filter((a) => { return a.Pass === this.tracker.currentPass && !a.isExhausted() })
      if (checkPass.length <= 0) { ++this.tracker.currentPass }
      this.sort()
    },
    checkExistsAndAdd (arr, checkItem) {
      let combatantExistsArr = arr.filter((item) => { return item.Id === checkItem.Id })
      if (combatantExistsArr.length <= 0) { arr.push(checkItem) }
    },
    clear () {
      this.tracker.items = []
      this.tracker.lastId = 1
      this.tracker.currentPass = 1
    },
    closeDialog (dialogName) {
      if (dialogName === 'combatantDialog') {
        this.showCombatantDialog = false
      }
      if (dialogName === 'initiativeDialog') {
        this.showInitiativeDialog = false
      }
    },
    modify (index) {
      this.openModifyDialog(index)
    },
    moveNext () {
      this.combatantDialogModel.currentIndex += 1
      this.combatantDialogModel.currentItem = this.combatantDialogModel.items[this.combatantDialogModel.currentIndex]
    },
    moveNextOrSave () {
      if (this.combatantDialogModel.items.length > 1 && this.combatantDialogModel.currentIndex < (this.combatantDialogModel.items.length - 1)) {
        this.moveNext()
      } else {
        this.saveCombatant()
      }
    },
    movePrev () {
      this.combatantDialogModel.currentIndex -= 1
      this.combatantDialogModel.currentItem = this.combatantDialogModel.items[this.combatantDialogModel.currentIndex]
    },
    nextElement () {
      this.$refs.combatantDialog_initiative.focus()
      this.$refs.combatantDialog_initiative.select()
    },
    openCombatDialog (combatants) {
      this.combatantDialogModel.items = combatants
      this.combatantDialogModel.currentIndex = 0
      this.combatantDialogModel.currentItem = this.combatantDialogModel.items[this.combatantDialogModel.currentIndex]
      this.showCombatantDialog = true
      setTimeout(() => {
        this.$refs.combatantDialog_name.focus()
        this.$refs.combatantDialog_name.select()
      }, 100)
    },
    openCombatDialogByCaptureEvent (event, combatants) {
      console.log(event)
      if (event.srcElement.nodeName.search(/button/gi) >= 0) { return }
      this.openCombatDialog(combatants)
    },
    openModifyDialog (index) {
      this.initiativeDialogModel.Index = index
      this.initiativeDialogModel.Modifier = 0
      this.showInitiativeDialog = true
      setTimeout(() => {
        this.$refs.initiativeDialog_modifier.focus()
        this.$refs.initiativeDialog_modifier.select()
      }, 100)
    },
    remove (index) {
      this.tracker.items.splice(index, 1)
      this.sort()
    },
    reset () {
      this.tracker.items.forEach((item) => { item.Initiative = 0; item.Pass = 1; item.Priority = false })
      this.tracker.currentPass = 1
      this.openCombatDialog(this.tracker.items)
    },
    saveCombatant () {
      this.showCombatantDialog = false
      for (let x = 0; x < this.combatantDialogModel.items.length; x++) {
        let combatant = this.combatantDialogModel.items.pop()
        combatant.Score = combatant.Initiative
        combatant.Pass = 1
        this.checkExistsAndAdd(this.tracker.items, combatant)
      }
      this.sort()
    },
    saveInitiative () {
      this.showInitiativeDialog = false
      if (this.initiativeDialogModel.Index >= 0) {
        let combatants = this.tracker.items.splice(this.initiativeDialogModel.Index, 1)
        let combatant = combatants[0]
        combatant.Initiative += this.initiativeDialogModel.Modifier
        if (this.initiativeDialogModel.IsGlobal) { combatant.Score += this.initiativeDialogModel.Modifier }
        this.checkExistsAndAdd(this.tracker.items, combatant)
      }
      this.sort()
    },
    sort () {
      this.tracker.items.sort((a, b) => {
        if (a === null || a === undefined) { return 0 }
        if (b === null || b === undefined) { return 0 }
        if (b.isExhausted() && a.isExhausted()) { return -100 }
        if (b.isExhausted()) { return -100 }
        if (a.isExhausted()) { return 100 }
        let passDiff = a.Pass - b.Pass
        if (passDiff === 0) {
          if ((a.Priority && b.Priority) || (!a.Priority && !b.Priority)) {
            if (b.Initiative - a.Initiative === 0) {
              return b.Score - a.Score
            }
            return b.Initiative - a.Initiative
          } else {
            if (a.Priority) { return -100 }
            if (b.Priority) { return 100 }
          }
        }
        return passDiff
      })
    }
  },
  mounted () {
    self.document.addEventListener('keydown', (event) => {
      if (event.key === 'a' && event.altKey) {
        this.$refs.comabtGrid_addButton.click()
      }
    }, true)
  }
}
export class Combatant {
  constructor (id, init, name, priority) {
    if (id === null || id === undefined) { id = 0 }
    if (init === null || init === undefined) { init = 0 }
    if (name === null || name === undefined) { name = '' }
    if (priority === null || priority === undefined) { priority = false }
    this.Id = id
    this.Name = name
    this.Initiative = init
    this.Score = init
    this.Priority = priority
    this.Pass = 0
  }
  isExhausted () {
    return this.Initiative <= 0
  }
}
</script>
<style scoped>
  div.panel {
    margin-left: auto;
    margin-right: auto;
    max-width: 95%;
  }
  p {
    font-weight: bold;
  }
  table {
    border-collapse: collapse;
    border: 1px solid #000;
    margin-left: auto;
    margin-right: auto;
  }
    table tr {
      border: 1px solid #000;
    }
      table tr th, table tr td {
        border: 1px #000 solid;
        padding-left: 10px;
        padding-right: 10px;
      }
  .exhausted {
    color: #AAA !important;
    text-decoration: line-through #ccc solid !important;
    background-color: rgba(51, 51, 51, 0.3) !important;
  }
  .combatantRow {
    color: #000;
    background-color: #fff;
  }
    .combatantRow:nth-child(even) {
      background-color: rgba(151, 151, 151, 1);
    }

  button {
    margin-top: 5px;
    margin-bottom: 5px;
    color: #555;
    font-size: 1.2em;
    font-weight: bold;
  }
    button:hover,
    button:focus {
      color: darkblue;
      text-decoration: none;
      cursor: pointer;
    }
    button.disabled {
      color: #aaa;
    }
    button.hidden {
      display: none;
    }
</style>
